import { DOMAIN } from 'utils'

const ArticoloSchemaOrg = ({ articolo }) => {
  const autori = articolo.utenti.length ? articolo.utenti : []

  let articleSchema = {
    '@context': 'http://schema.org',
    '@type': 'Article',
    'headline': articolo.titolo,
    'image': `${DOMAIN}${articolo.main_image}`,
    'publisher': {
      '@type': 'Organization',
      'name': 'Giunti Scuola',
      'logo': {
        '@type': 'ImageObject',
        'url': `${DOMAIN}/favicon.ico`,
      },
    },
    'description': articolo.descrizione,
    'datePublished': articolo.data_jsonld,
  }

  if (articolo.visibilita != 'tutti') {
    articleSchema['isAccessibleForFree'] = 'False'
    articleSchema['hasPart'] = {
      '@type': 'WebPageElement',
      'isAccessibleForFree': 'False',
      'cssSelector': '.articolo-page__content',
    }
  }

  if (autori.length) {
    articleSchema['author'] = {
      '@type': 'Person',
      'name': autori[0].nome + ' ' + autori[0].cognome,
    }
  }

  return (
    <script
      key={`jobJSON-${articolo.id}`}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }}
    />
  )
}

export default ArticoloSchemaOrg
